import React from 'react';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import RoutableSitecoreLink from '@hedinbil/hedin-ui/dist/utils/RoutableSitecoreLink';
import { hrefToSitecoreLink } from '../../../Project/bavaria-no/utils/hrefToSitecoreLink';

export const DefaultContactView = ({ reseller, sendEventToGTM }) => {
  const mapHref =
    'https://www.google.com/maps/search/?api=1&query=' +
    reseller?.name +
    '+' +
    reseller?.contactCompany?.adress;

  return (
    <>
      {reseller?.contactCompany?.adress && (
        <div>
          <a href={mapHref} className="contact-link d-flex">
            <HedinIcon iconName="CarContactPin" />
            {reseller?.contactCompany?.adress}
          </a>
        </div>
      )}
      {reseller?.contactCompany?.phone && (
        <div>
          <a
            href={`tel:${reseller?.contactCompany?.phone}`}
            className="contact-link d-flex"
            onClick={() => sendEventToGTM('contactStore')}
          >
            <HedinIcon iconName="Phone" />
            {reseller?.contactCompany?.phone}
          </a>
        </div>
      )}
      {reseller?.contactCompany?.email && (
        <div>
          <a
            href={`mailto:${reseller?.contactCompany?.email}`}
            className="contact-link d-flex"
            onClick={() => sendEventToGTM('contactStore')}
          >
            <HedinIcon iconName="Mail" />
            {reseller?.contactCompany?.email}
          </a>
        </div>
      )}
      <br />
      <div>
        <RoutableSitecoreLink
          field={hrefToSitecoreLink(reseller?.buttonHref)}
          className="button button--naked button--icon"
        >
          {reseller?.buttonText ? reseller?.buttonText : 'Gå till anläggning'}
        </RoutableSitecoreLink>
      </div>
    </>
  );
};
